// Clearly-labeled advertorial/sponsored marker, shown on the public article
// detail view whenever `article.is_sponsored` is true. Renders nothing otherwise.
export default function SponsoredBadge({ article, className = '' }) {
  if (!article?.is_sponsored) return null;
  const label = article.sponsor_label ? `Sponsored by ${article.sponsor_label}` : 'Sponsored Content';
  return (
    <span
      data-testid="sponsored-badge"
      title="This is paid/advertorial content, clearly labeled per advertising disclosure guidelines."
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide bg-amber-100 text-amber-800 border border-amber-300 ${className}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3 h-3">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0 3.75h.008M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      {label}
    </span>
  );
}
